const options = {
  sans: "font-sans",
  serif: "font-serif",
  mono: "font-mono",
};

export default function getFontFamily(value) {
  return options[value];
}
